import { Button, Typography} from "@mui/material";
import React, { useEffect, useState } from "react";
import  useStyles from "../../styles";
import loadingLogo from "../../../../../assets/loadingS.png";
import checkPng from "../../../../../assets/check.png";
import redCross from "../../../../../assets/redcross.png";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../../FundingsSource/redux/slice";
import { selectUser } from "app/containers/Auth/selectors";
import { selectIdVerificationRequest, selectIdVerificationBank, selectLoading } from "app/containers/Auth/FundingsSource/redux/selectors";
import { VerificationStatus } from "app/containers/Auth/FundingsSource/redux/enum";
import Loader from "app/components/Loader";
import { useNavigate } from "react-router-dom";
import { LoggerClass } from "utils/logger";

 
const BankVerification = ({connectionResponse}) => {
    const styles = useStyles();
    const dispatch = useDispatch();
    const navigation = useNavigate(); 
    const loggedinUser = useSelector(selectUser);
    const idVerificationRequest = useSelector(selectIdVerificationRequest);
    const idVerificationBank = useSelector(selectIdVerificationBank);
    const loading = useSelector(selectLoading);
    const [buttonEnable, setButtonEnable] = useState(false);

    const handleClick = () => {
      LoggerClass.info("Go to plaid again");
    }
const VerificationStatusText = (type) => { 
    switch (type) {
      case VerificationStatus.VERIFIED:
        return 'Done';
      case VerificationStatus.RETRY:
        return 'Pending';
      case VerificationStatus.DOCUMENT:
        return 'Pending';
      case VerificationStatus.SUSPENDED:
        return 'Failed';      
      default:
        return '';
    }
  }

    useEffect(() => {  
      if(idVerificationRequest.UserId.value) {
          dispatch(actions.checkBankIDverification(idVerificationRequest));
      }  
    }, [idVerificationRequest]);
  
    useEffect(() => {  
      if(idVerificationBank.status !== VerificationStatus.VERIFIED) {
          setButtonEnable(true);
          connectionResponse(false);
        }  else {
          setButtonEnable(false);
          connectionResponse(true);
        }  
    }, [idVerificationBank]);

  return ( 
    <>
      {/* <Loader loading={loading} />     */}

    <div className={VerificationStatusText(idVerificationBank.status) === "Done" ? styles.statusDoneSection : styles.statusSection}>         
        <img
          className={VerificationStatusText(idVerificationBank.status) === "Pending" ? styles.DoneImage : styles.PendingImage}
          src={VerificationStatusText(idVerificationBank.status) === "Done" ? checkPng : VerificationStatusText(idVerificationBank.status) === "Pending" ? loadingLogo : redCross }
          alt={"..."}
        />
        <Typography className={styles.textLine}>
          Bank Account Verification: <span className={VerificationStatusText(idVerificationBank.status) === "Done" ? styles.Done : VerificationStatusText(idVerificationBank.status) === "Pending" ? styles.Pending : styles.Failed}>{VerificationStatusText(idVerificationBank.status) }</span>
        </Typography> 

        {buttonEnable && <Button
        className={styles.ConnectInButton}
        variant="contained"
        onClick={handleClick}
        >
        Verify Bank Account
        </Button>  }         
    </div> 
    </> 
  );
};

export default BankVerification;
